import { render } from "./elementbreadcrumb.vue?vue&type=template&id=9d2f4aac"
import script from "./elementbreadcrumb.vue?vue&type=script&lang=js"
export * from "./elementbreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__